module.exports = __webpack_public_path__ + "assets/usa-flag.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/usa-flag.png
// module id = 1674
// module chunks = 7